const A = "location", t = "date_from", o = "date_to", _ = "adults";
export {
  _ as PARAM_ADULTS,
  t as PARAM_DATE_FROM,
  o as PARAM_DATE_TO,
  A as PARAM_LOCATION
};
